import { gql } from "@apollo/client";

export const UPDATE_BUCKET = gql`
mutation createOrUpdateBucket($input: [BucketInput]!) {
  createOrUpdateBucket(input: $input) {
    data {
      ARCIMEDES_ROW_ID
      AGENT_ID
      START_DATE
      CALLS
      MEETINGS
      STRIVE_START_DATE
      ARCIMEDES_CREATED
      ARCIMEDES_CREATED_BY
      ARCIMEDES_MODIFIED
      ARCIMEDES_MODIFIED_BY
    }
    error
    message
    success
  }
}
`